import type { Locale } from 'date-fns';

const DATE_LOCALE_LOADERS: Record<string, () => Promise<Locale>> = {
  ru: () => import('date-fns/locale/ru').then((mod) => mod.ru),
  en: () => import('date-fns/locale/en-US').then((mod) => mod.enUS),
  kz: () => import('date-fns/locale/kk').then((mod) => mod.kk),
  de: () => import('date-fns/locale/de').then((mod) => mod.de),
  uk: () => import('date-fns/locale/uk').then((mod) => mod.uk),
};

const loadedDateLocales = new Map<string, Locale>();

export const getLoadedDateLocale = (locale: string) =>
  loadedDateLocales.get(locale);

export const loadDateLocale = async (locale: string) => {
  const loader = DATE_LOCALE_LOADERS[locale];
  if (!loader) return undefined;

  const dateLocale = await loader();
  loadedDateLocales.set(locale, dateLocale);
  return dateLocale;
};
